module.exports = __webpack_public_path__ + "static/c_tom-4dd7ff9cf9458c943ff61528b6ff68b8.png";